/** 后台页面共用的少量展示组件。颜色与圆角全部走 @hew3/shared 注入的 CSS 令牌。 */
import type { ReactNode } from 'react';

export function Card({
  title,
  sub,
  actions,
  children,
  tight,
}: {
  title?: ReactNode;
  sub?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
  tight?: boolean;
}) {
  return (
    <section className={`card${tight ? ' tight' : ''}`}>
      {title !== undefined && (
        <div className="card-hd">
          <div className="card-tt">
            <span className="bar" />
            {title}
            {sub !== undefined && <small>{sub}</small>}
          </div>
          {actions !== undefined && <div>{actions}</div>}
        </div>
      )}
      {children}
    </section>
  );
}

export function Kpi({
  label,
  value,
  tone,
  delta,
}: {
  label: ReactNode;
  value: ReactNode;
  tone?: 'danger' | 'warn' | 'e' | 'w';
  delta?: ReactNode;
}) {
  return (
    <div className="kpi">
      <div className="k-l">{label}</div>
      <div className={`k-v${tone ? ` ${tone}` : ''}`}>{value}</div>
      {delta !== undefined && <div className="k-d">{delta}</div>}
    </div>
  );
}

type BadgeTone = 'h' | 'e' | 'w' | 'ok' | 'warn' | 'danger' | 'ghost';

export function Badge({ tone = 'ghost', children }: { tone?: BadgeTone; children: ReactNode }) {
  return <span className={`badge ${tone}`}>{children}</span>;
}

/**
 * 无权限占位。**刻意与 0 长得完全不同**：
 * 「看不到」和「是 0」在后台是完全不同的结论，混用会导致误判。
 */
export function NoPermission({ what }: { what?: string }) {
  return (
    <span className="no-perm" title={what ? `${what}：当前角色无权查看该字段` : '当前角色无权查看该字段'}>
      🔒 无权限查看
    </span>
  );
}

/** 无权限区块：说明「为什么看不到」，而不是留白。 */
export function PermissionBlock({ title, desc }: { title: string; desc: string }) {
  return (
    <div className="perm-block">
      <div className="pb-t">🔒 {title}</div>
      <div>{desc}</div>
    </div>
  );
}

export function PageHead({ title, sub, actions }: { title: string; sub?: string; actions?: ReactNode }) {
  return (
    <div className="page-head">
      <div className="grow">
        <div className="page-title">{title}</div>
        {sub !== undefined && <div className="page-sub">{sub}</div>}
      </div>
      {actions}
    </div>
  );
}
